<ng-container *transloco="let convert;">
  @if (missingItems) {
    <div class="card mb-3">
      <div class="multi-vin-container">
        <div class="d-flex">
          <i class="allycon-error-fill text-destructive pe-2" aria-hidden="true"></i>
          <div aria-live="polite" aria-atomic="true" class="overflow-hidden">
            <strong>{{convert('sellModule.manageInventory.multiVinError.textCouldntFind')}} {{ missingItems.length }} {{ type === 'VIN' ? convert('sellModule.manageInventory.multiVinError.textVIN') : convert('sellModule.manageInventory.multiVinError.textStockUnit') }}{{ missingItems.length > 1 ? 's' : '' }}. {{convert('sellModule.manageInventory.multiVinError.textContactHelp')}}</strong>
            <div class="vin-list">
              {{ missingItems.join(', ') }}
              <button allytmln='multiVinErrorShowMore' class="btn btn-link p-0"
                (click)="showModal()">
                <span>
                  {{convert('common.btnSeeMore')}}
                </span>
              </button>
            </div>
          </div>
        </div>
        <button class="error__close" [attr.aria-label]="convert('sellModule.manageInventory.multiVinError.btnCloseError')" (click)="closeError()" data-track-elem="icon"
          data-track-name="Close" data-track-trigger="close">
          @if (configuration) {
            <img src="../../../ui/assets/assets-{{ configuration.tenantName }}/{{ configuration.tenantName }}-close.svg"
              alt="{{convert('sellModule.manageInventory.multiVinError.altCloseErrorIcon')}}" />
          }
        </button>
      </div>
    </div>
    <app-multi-vin-error-modal [vins]="missingItems"></app-multi-vin-error-modal>
  }
</ng-container>
